export default __webpack_public_path__ + "static/media/documents.6f1a5a80.svg";